/** @format */

export enum STUDENT_APPLICATION_STATE {
    REQUESTED = 'REQUESTED',
    REJECTED = 'REJECTED',
    ACCEPTED = 'ACCEPTED',
    IN_HANDLING = 'IN_HANDLING',
    CANCELLED = 'CANCELLED',
    CONDITIONAL = 'CONDITIONAL',
    REVOKED = 'REVOKED',
    ACCEPTANCE_REVOKED = 'ACCEPTANCE_REVOKED',
    SUPPLEMENT_REQUESTED = 'SUPPLEMENT_REQUESTED',
}

export enum STUDENT_APPLICATION_TYPE {
    MODULE_ATTAINMENT_APPLICATION = 'ModuleAttainmentApplication',
    DEGREE_PROGRAMME_ATTAINMENT_APPLICATION = 'DegreeProgrammeAttainmentApplication',
    PRIOR_LEARNING_INCLUSION_APPLICATION = 'PriorLearningInclusionApplication',
    PRIOR_LEARNING_SUBSTITUTION_APPLICATION = 'PriorLearningSubstitutionApplication',
    CUSTOM_ATTAINMENT_APPLICATION = 'CustomAttainmentApplication',
    CUSTOM_MODULE_CONTENT_APPLICATION = 'CustomModuleContentApplication',
    REQUIRED_MODULE_CONTENT_APPLICATION = 'RequiredModuleContentApplication',
    STUDY_RIGHT_EXTENSION_APPLICATION = 'StudyRightExtensionApplication',
}
